import { createState, useState } from '@hookstate/core';

interface ContractReviewListState {
  detailDrawerOpen: boolean;
  contractId: string;
}

const initialState: ContractReviewListState = {
  detailDrawerOpen: false,
  contractId: '',
};

const contractReviewListState = createState(initialState);

export function useContractReviewListState() {
  return useState(contractReviewListState);
}
